export const serviceOrderHeaderOptions = [
  // { label: 'Dispatch', value: 'Dispatch', callback: 'onClickDispatch' }
  { label: 'Print', value: 'print', callback: 'onClickPrint' }
  // { label: 'Export', value: 'export', callback: 'onClickExport' }
];
